import * as React from "react";

// importing material UI components
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import '../App.css'
import logo from '../logo-clear-banner.png'


export default function Header() {
return (
    <div className="Title">
    <Button className="button-clear" href="https://site-test-caleighd23.vercel.app/">
        <div className="image-container">
            <img className="Title-name" src={logo} alt="Website logo" width={300} height={80}/>
            <div className="Title-Subtitle">Learning the environment through data. </div>
        </div>
        </Button>
		<Toolbar>
            <div className = "toolbar">
                <Button color="inherit" href=".">Blockly Home</Button>
                <Button color="inherit" href="/level0">Level 0</Button>
                <Button color="inherit" href="/level1">Level 1</Button>
                <Button color="inherit" href="/level2">Level 2</Button>
                <Button color="inherit" href="/level3">Level 3</Button>
                <Button color="inherit" href="/level4">Level 4</Button>
                <Button color="inherit" href="/level5">Level 5</Button>
                <Button color="inherit" href="/level6">Level 6</Button>
                <Button color="inherit" href="/playground">Playground</Button>
            </div>
		</Toolbar>
    </div>
);
}
